// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2GLC5","slider":"styles_slider__W84aP"};